import { ref } from 'vue'
import { getPrivacyFlag, updatePrivacyFlag } from '@/api/global'
import { PRIVACY_SWITCH, PRIVACY_STORAGE_KEY } from './const'

// 隐私开关状态
const privacyState = ref(PRIVACY_SWITCH.CLOSE)

export default () => {
  // localStorage获取
  const getPrivacyLocal = () => {
    return localStorage.getItem(PRIVACY_STORAGE_KEY)
  }
  // localStorage更新
  const modifyPrivacyLocal = (val) => {
    privacyState.value = val.toString()
    localStorage.setItem(PRIVACY_STORAGE_KEY, val)
  }
  // 远程获取
  const getPrivacyRemote = () => {
    return new Promise((resolve) => {
      getPrivacyFlag().then((res) => {
        const { code, data } = res
        if (code === 1) {
          modifyPrivacyLocal(data)
          resolve(data)
        }
      })
    })
  }
  // 远程更新
  const modifyPrivacyRemote = (val) => {
    return updatePrivacyFlag(val).then((res) => {
      const { code, data } = res
      if (code === 1 && data) {
        modifyPrivacyLocal(val)
      }
    })
  }

  return {
    privacyState,
    getPrivacyLocal,
    modifyPrivacyLocal,
    getPrivacyRemote,
    modifyPrivacyRemote,
  }
}
